import axios from 'axios';
import { SentimentResponse } from '../types/sentiment.type';

import { apiBase } from './apiBase';
export const getSentimentData = ({
  token,
  ric,
  interval,
  days,
}: {
  token: string;
  ric: string;
  days: string;
  interval: string;
}): Promise<SentimentResponse | undefined> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/sentiment`,
        {
          params: { token, ric, interval, days },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
